import en from './payouts.en.json';
const enConfig = { en };

export default enConfig;
